import {Component, OnDestroy, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";

@Component({
  selector: 'app-site-blocked',
  templateUrl: './site-blocked.component.html',
  styleUrls: ['./site-blocked.component.scss']
})
export class SiteBlockedComponent implements OnDestroy, OnInit {
  private timer = 0;
  constructor(
    private titleService: Title,
    private meta: Meta,
    private router: Router,
  ) {
    const title = "Маслоточка | Заблоковано";

    this.titleService.setTitle(title);
    this.meta.addTag({ name: 'title', content: title });
  }

  ngOnInit() {
    this.timer = setInterval(() => {
      this.router.navigate([`account`]);
    }, 30000);
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }
}
